import {useLocation} from 'react-router';

export const useSearchParam = (): URLSearchParams => {
    return new URLSearchParams(useLocation().search);
}
